import { call, all, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { createEffect } from './creator';
import {
    USER_CHECK_STATUS,
    checkStatus,
    USER_SIGN_OUT,
    signOut,
    USER_GET_USER_SETTING,
    getUserSetting,
    USER_SET_USER_SETTING,
    setUserSetting,
    USER_GET_INFO,
    getInfo,
    USER_GET_CLIENT_INFO,
    getClientInfo,
    USER_GET_CLIENT_DETAIL,
    getClientDetail,
    USER_GET_PASSPORT_DETAIL,
    getPassportDetail,
    USER_SET_INFO,
    USER_GET_ROLES,
    getRoles,
} from '../actions/user';
import UserApi from 'pc-sales/api.v2/user';
import PassportApi from 'pc-sales/api.v2/passport';
import SystemApi from 'pc-sales/api.v2/system';

export default [
    // 获取当前用户信息
    takeLatest(
        USER_CHECK_STATUS,
        createEffect(function* (): any {
            try {
                const data = yield call(UserApi.checkStatus);
                yield put(checkStatus.succeeded(data));
            } catch (err) {
                yield put(checkStatus.failed());
                throw err;
            }
        }),
    ),
    // 退出登录
    takeLatest(
        USER_SIGN_OUT,
        createEffect(function* (action: Action.Async): any {
            try {
                yield call(UserApi.signOut, action.payload);
                yield put(signOut.succeeded());
                window.location.reload();
            } catch (err) {
                yield put(signOut.failed());
                throw err;
            }
        }),
    ),

    // 获取CRM账户详情
    takeEvery(
        USER_GET_CLIENT_INFO,
        createEffect(function* getClientInfoEffect(action: Action.Async): any {
            const { payload } = action;
            try {
                const data = yield call(UserApi.client.crmInfo, payload);
                yield put(getClientInfo.succeeded(data));
                return data;
            } catch (err) {
                yield put(getClientInfo.failed());
                throw err;
            }
        }),
    ),

    // 获取CRM账户详情
    takeLatest(
        USER_GET_CLIENT_DETAIL,
        createEffect(function* (action: Action.Async): any {
            try {
                // 获取注册设置
                const setting = yield call(SystemApi.getSetting, {
                    keys: [
                        'KYC_Personal',
                        'KYC_RealName',
                        'KYC_Identification',
                        'KYC_Autograph',
                        'KYC_Family',
                        'KYC_Contact',
                        'KYC_Employment',
                        'KYC_Finance',
                        'KYC_Invest',
                        'KYC_Address',
                        'KYC_Tax',
                    ],
                });
                const settingKYC = yield call(SystemApi.getSetting, {
                    keys: ['KYC_Setting'],
                });
                const archives = yield call(UserApi.archives.info, {
                    uuid: action.payload.uuid,
                    // fields: {
                    //     archives_personal: ['lastName', 'firstName', 'nationality', 'birthCountry', 'localName', 'gender', 'birthday'],
                    //     archives_real: ['method', 'status', 'idName']
                    // }
                });

                const res = ((tasks: {
                    [key: string]: {
                        archives: any;
                        auditArchives?: any;
                        setting?: any;
                    };
                }) =>
                    Object.entries(tasks).reduce((prev: any, [key, value]) => {
                        const { data, ...progress } = value.archives || ({} as any);
                        if (!progress.status) progress.status = 'uncommitted';
                        return {
                            ...prev,
                            [key]: {
                                enabled: settingKYC.KYC_Setting.enabled.includes(key),
                                progress,
                                archives: data,
                                setting: value.setting,
                            },
                        };
                    }, {}))({
                    personal: {
                        archives: archives.archives_personal,
                        setting: setting.KYC_Personal,
                    },
                    realName: {
                        archives: archives.archives_real,
                        setting: setting.KYC_RealName,
                    },
                    family: {
                        archives: archives.archives_family,
                        setting: setting.KYC_Family,
                    },
                    contact: {
                        archives: archives.archives_contact,
                        setting: setting.KYC_Contact,
                    },
                    identification: {
                        archives: archives.archives_id,
                        setting: setting.KYC_Identification,
                    },
                    address: {
                        archives: archives.archives_address,
                        setting: setting.KYC_Address,
                    },
                    tax: {
                        archives: archives.archives_tax,
                        setting: setting.KYC_Tax,
                    },
                    employment: {
                        archives: archives.archives_employment,
                        setting: setting.KYC_Employment,
                    },
                    finance: {
                        archives: archives.archives_finance,
                        setting: setting.KYC_Finance,
                    },
                    invest: {
                        archives: archives.archives_invest,
                        setting: setting.KYC_Invest,
                    },
                    autograph: {
                        archives: archives.archives_autograph,
                        setting: setting.KYC_Autograph,
                    },
                    riskLevel: {
                        archives: archives.archives_riskLevel,
                        setting: setting.KYC_RiskLevel,
                    },
                });
                yield put(getClientDetail.succeeded(res));
                return res;
            } catch (err) {
                yield put(getClientDetail.failed());
                throw err;
            }
        }),
    ),

    // 获取用户设置
    takeEvery(
        USER_GET_USER_SETTING,
        createEffect(function* (action: Action.Async): any {
            const { payload } = action;
            try {
                const res = yield call(UserApi.getSetting, payload);
                const data = res.reduce((prev: any, { ukey, uvalue }: any) => ({ ...prev, [ukey]: uvalue }), {});
                yield put(getUserSetting.succeeded(data));
            } catch (err) {
                yield put(getUserSetting.failed());
                throw err;
            }
        }),
    ),
    // 保存用户设置
    takeLatest(
        USER_SET_USER_SETTING,
        createEffect(function* (action: Action.Async): any {
            const { payload } = action;
            try {
                yield call(UserApi.setSetting, payload);
                yield put(
                    setUserSetting.succeeded({
                        [payload.ukey]: payload.uvalue,
                    }),
                );
            } catch (err) {
                yield put(setUserSetting.failed());
                throw err;
            }
        }),
    ),

    // 获取通行证信息
    takeEvery(
        USER_GET_PASSPORT_DETAIL,
        createEffect(function* getPassportDetailEffect(action: Action.Async): any {
            const { payload } = action;
            if (payload.type === 'updateData') {
                yield put(getPassportDetail.succeeded(payload.values));
                return payload.values;
            }
            try {
                const data = yield call(PassportApi.userInfo, payload);
                yield put(getPassportDetail.succeeded(data));
                return data;
            } catch (err) {
                yield put(getPassportDetail.failed());
                throw err;
            }
        }),
    ),

    // 获取用户信息
    takeEvery(
        USER_GET_INFO,
        createEffect(function* (action: Action.Async): any {
            try {
                const data = yield call(UserApi.info, action.payload);
                yield put(getInfo.succeeded(data));
            } catch (err) {
                yield put(getInfo.failed());
                throw err;
            }
        }),
    ),
    // 更新用户信息
    takeEvery(
        USER_SET_INFO,
        createEffect(function* (action: Action.Async) {
            try {
                yield call(UserApi.update, action.payload);
            } catch (err) {
                throw err;
            }
        }),
    ),
    // 获取角色
    takeEvery(
        USER_GET_ROLES,
        createEffect(function* (action: Action.Async): any {
            const { payload } = action;
            try {
                const { utype, pagesize, return_type, ...rest } = payload;
                const keys = utype.split(',');
                const res = yield all(
                    keys.map((item: string) => call(UserApi.role, { ...rest, utype: item, pagesize: pagesize || 0 })),
                );
                const roles = keys.reduce(
                    (prev: any, curr: any, index: number) => ({
                        ...prev,
                        [curr]: res[index],
                    }),
                    {},
                );
                yield put(getRoles.succeeded(roles));
                if (return_type === 'list') {
                    return keys.length === 1 ? roles[utype] : roles;
                }
                if (return_type === 'map') {
                    return res
                        .reduce((prev: any, { data }: any) => {
                            return prev.concat(data);
                        }, [])
                        .reduce(
                            (prev: any, { id, role_name }: any) => ({
                                ...prev,
                                [id]: role_name,
                            }),
                            {},
                        );
                }
                if (return_type === 'option') {
                    return res.reduce((prev: Array<any>, { data }: any) => {
                        return prev.concat(
                            data.map(({ role_name, id }: any) => ({
                                label: role_name,
                                value: id,
                            })),
                        );
                    }, []);
                }
            } catch (err) {
                yield put(getRoles.failed());
                throw err;
            }
        }),
    ),
];
